"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputLabel = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
/**
 * @deprecated use the `@hopin-team/ui-field-label` component instead.
 */


var LabelContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-bottom: 0.5rem;\n"], ["\n  margin-bottom: 0.5rem;\n"])));
var Label = styled_components_1.default.label(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-style: normal;\n  font-weight: 500;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: var(--color-text-label);\n"], ["\n  font-style: normal;\n  font-weight: 500;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: var(--color-text-label);\n"])));

function InputLabel(props) {
  return react_1.default.createElement(LabelContainer, null, react_1.default.createElement(Label, tslib_1.__assign({}, props)));
}

exports.InputLabel = InputLabel;
var templateObject_1, templateObject_2;